import { either } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { noop } from 'lodash';
import { ModelContext } from 'modules/Models/components/ModelContext/ModelContext';
import { ReactLeft, reactLeftToJSX } from 'utils/uiStates/uiStates';

type ModelContextProviderProps = { modelE: either.Either<ReactLeft, CF.API.Models.Model>; refetchModel?: () => void };
export const ModelContextProvider: React.FC<ModelContextProviderProps> = ({ modelE, refetchModel, children }) =>
  pipe(
    modelE,
    either.fold(reactLeftToJSX(undefined, { showErrorCTA: true }), (model) => (
      <ModelContext.Provider value={{ model, refetchModel: refetchModel ?? noop }}>{children}</ModelContext.Provider>
    )),
  );
